import React from 'react';

import {
	MELTINGSPOT_SPOT_ID
} from '~/config';

import ScreenLayout from '../patterns/screens/basicScreen/layouts/ScreenLayout';

import useExternalScript from '~/hooks/useExternalScript';
import useMeltingspotToken from '~/hooks/useMeltingspotToken';



function onMeltingSpotLoaded(token: string | null) {
	document.getElementById('meltingspot-frame')?.replaceChildren()

	if (token) {
		// @ts-expect-error MeltingSpot is untyped
		window.MeltingSpot?.injectSpotInto(
			'meltingspot-frame',
			{
				spotId: MELTINGSPOT_SPOT_ID,
				themeMode: 'light',
				authToken: token,
			}
		);
	}
}



const CommunityScreen: React.FC = () => {
	const { token, loading, error } = useMeltingspotToken();
	const [scriptLoaded, setScriptLoaded] = React.useState(false);

	useExternalScript('https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js', () => {
		setScriptLoaded(true);
	});

	React.useEffect(() => {
		if (scriptLoaded && token) {
			onMeltingSpotLoaded(token);
		}
	}, [scriptLoaded, token]);

	if (loading) {
		return (
			<ScreenLayout>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: 'calc(100vh - 4px)'
					}}
				>
					<div>Loading community...</div>
				</div>
			</ScreenLayout>
		);
	}

	if (error) {
		return (
			<ScreenLayout>
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: 'calc(100vh - 4px)',
						flexDirection: 'column',
						gap: '16px'
					}}
				>
					<div>Unable to load Community</div>
					<div style={{ color: '#666', fontSize: '14px' }}>{error}</div>
				</div>
			</ScreenLayout>
		);
	}

	return (
		<ScreenLayout>
			<div
				id="meltingspot-frame"
				style={{ width: '100%', height: 'calc(100vh - 4px)' }}
			>
			</div>
		</ScreenLayout>
	);
};



export default CommunityScreen;
